module.exports = __webpack_public_path__ + "img/icon-home-app-active.9c03718a.svg";